module.exports = __webpack_public_path__ + "static/img/5.76419b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/5.png
// module id = Vpx2
// module chunks = 0